import { GET_SURVEY_BRAND, GetSurveyBrand, SET_SURVEY_BRAND, SetSurveyBrand, SurveyBrand } from './types';

export const getSurveyBrandAction = (id: string): GetSurveyBrand => ({ type: GET_SURVEY_BRAND, payload: { id } });

export const setSurveyBrandAction = (brand: SurveyBrand): SetSurveyBrand => ({
	type: SET_SURVEY_BRAND,
	payload: brand,
});
